/* FUKUI theme — product page section numbering
   The product page runs a numbered sequence (01/ description, 02/ guide, …).
   Turning a section off in the theme editor would otherwise leave a hole in
   that run, so the numbers are renumbered in document order after render.
   Only plain "NN/" markers are touched; a custom label is left alone. */
(function () {
  'use strict';

  function renumber() {
    var i = 0;
    Array.prototype.forEach.call(document.querySelectorAll('.idx b'), function (el) {
      if (!/^\d{1,2}\/$/.test((el.textContent || '').trim())) return;
      i++;
      el.textContent = (i < 10 ? '0' + i : String(i)) + '/';
    });
  }

  function later() { setTimeout(renumber, 0); }

  document.addEventListener('DOMContentLoaded', renumber);
  document.addEventListener('shopify:section:load', later);
  document.addEventListener('shopify:section:unload', later);
  document.addEventListener('shopify:section:reorder', later);
})();
